import { FlexDateType } from './type';

export const FLEX_DATES: Readonly<FlexDateType[]> = [
  {
    title: 'Точные даты',
    shiftValue: 0,
  },
  {
    title: '± 1 день',
    shiftValue: 1,
  },
  {
    title: '± 2 дня',
    shiftValue: 2,
  },
] as const;
